// from general.js
/* global isNonBlankCookie dcAnalytics */


$(document).ready(function () {
    function isNewUser() {
        return !isNonBlankCookie('userType') && !isNonBlankCookie('showProjectContext');
    }

    function projectCanBeFunded() {
        // Note that there are other reasons that might prevent a project from being fundable (workflow status of
        // SUSPENDED or ARCHIVED). But these two are common and easily checked, and the use-case is low-stakes enough
        // that we don't need to be comprehensive.
        return !window.fullyFunded && !window.isExpired;
    }

    if (isNewUser() && projectCanBeFunded()) {
        $('.js-context-intro').css('display', 'flex');
        createCookieWithSameSiteNone('showProjectContext', false, 0);
        if (dcAnalytics) {
            dcAnalytics.track('show context intro');
        }
    }

    $('body').on('donateOptionsAdded', function () {
        setTimeout(addPercentBar, 200);
    });
    function addPercentBar() {
        if (location.href.includes('context=true') &&
            $('#donateBar').find('.togo').attr('data-togo') &&
            $('#donateOptionsPercent').length === 0
        ) {
            $('#donateOptions').prepend('<div id="donateOptionsPercent"></div>');
            $('#donateOptionsPercent').append($('.js-mobile-donation-box').find('.donation-stats').clone());
            $('#donateOptionsPercent').append($('.js-mobile-donation-box').find('.progress-bar').clone());
        }
    }



    $( '.js-context-intro .bkg-close, .js-context-intro .container .icon, .js-context-intro .button-primary' ).on( 'click', function() {

        $('.js-context-intro').css('display','none');


    });




});
